import { Component } from "react";
import Button from "@material-ui/core/Button";

class SystemMaintenanceComponent extends Component {
  render() {
    return (
      <div>
        <h3>System maintenance</h3> <br />
        <hr />
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.setMaintenance.bind(this, 0)}
        >
          Maintenance
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.setMaintenance.bind(this, 1)}
        >
          Normal Access
        </Button>
      </div>
    );
  }
}
export default SystemMaintenanceComponent;
